import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[SiteType SetFilter] Action',
  ResetFilter: '[SiteType ResetFilter] Action',
}

const initialSiteTypeState: ISiteTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface ISiteTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-SiteType', whitelist: ['filter']},
  (state: ISiteTypeState = initialSiteTypeState, action: ActionWithPayload<ISiteTypeState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialSiteTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
